export default "__VITE_PUBLIC_ASSET__9f0b6c15__"